import { styled } from '@uhg-abyss/web/tools/styled';

export const ToolTipStyles = styled('div', {
  '.abyss-tooltip-trigger': {
    alignItems: 'flex-start',
    fontWeight: 'bold',
    height: '100%',
    justifyContent: 'center',
    left: '0px',
    margin: '0px',
    paddingLeft: 'var(--abyss-space-sm)',
    position: 'absolute',
    top: '0px',
    width: 'auto',
    zIndex: 10,
  },
});
